import { render, staticRenderFns } from "./UpdateAsset.vue?vue&type=template&id=03db274d&"
import script from "./UpdateAsset.vue?vue&type=script&lang=js&"
export * from "./UpdateAsset.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports